import { Component, OnInit } from '@angular/core';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../cfet-core';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-utf-syncing-information-page',
    templateUrl: './utf-syncing-information-page.component.html',
    styleUrls: ['./utf-syncing-information-page.component.scss'],
    standalone: false
})
export class UtfSyncingInformationPageComponent extends CfetBaseComponent implements OnInit {
  returnUrl = '';
  constructor(private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit () {
    const tokenUrl = {
      pilotUrl: true
    };
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params['returnURL']) {
        this.returnUrl = this.sanitizeReturnUrl(params['returnURL']);
      }
      if (this.returnUrl.length !== 0) {
        sessionStorage.setItem('returnUrl', JSON.stringify(this.returnUrl));
      }
    });
    sessionStorage.setItem('ngStorage-pilotToken', JSON.stringify(tokenUrl));
    window.location.href = environment.signup_domain + CfetPageNamesConstant.UTF_AUTH_PAGE;
  }

  private sanitizeReturnUrl(rawUrl: any): string {
    if (!rawUrl || typeof rawUrl !== 'string') {
      return '';
    }
    try {
      const parsed = new URL(rawUrl, window.location.origin);
      const allowedOrigins = [window.location.origin, environment.signup_domain];
      if (!/^https?:$/i.test(parsed.protocol) || allowedOrigins.indexOf(parsed.origin) === -1) {
        return '';
      }
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.toString();
    } catch (e) {
      return '';
    }
  }

}
